/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useState } from 'react';
import edit from '../../../../assets/img/icons/edit.png';
import view from '../../../../assets/img/icons/view.png';
import EditRelocation from './EditRelocation';
import ViewRelocation from './ViewRelocation';
import { NoItemRow, TizetiGIFLogoTable } from '../../../../utils/loader/loadingHelper';
import relocation_helpers from '../../../../utils/relocation/relocation_helpers';
import { useUser } from '../../../../hooks/shared/user/useUser';
import { SALES } from '../../../../utils/departments/helpers';
const RelocationTable = ({ lists, isLoading }) => {
  const colSpan = '8';
  const [request, setRequest] = useState({
    email: '',
    firstName: '',
    lastName: '',
    new_address: '',
    old_address: '',
    phoneNumber: '',
    id: '',
    note: '',
    created_at: '',
    payment_ref: '',
    relocation_status: '',
  });
  const getRequest = (item) => setRequest(item);

  const {
    user: { department_id },
  } = useUser();

  const tableData =
    lists && lists.length ? (
      lists.map((list, i) => {
        return (
          <tr className="" key={i}>
            <td>{i + 1}</td>
            <td className="text-nowrap">{`${list.firstName} ${list.lastName}`}</td>
            <td>{list.email}</td>
            <td>{list.phoneNumber}</td>
            <td className="text-nowrap">{list.old_address}</td>
            <td className="text-wrap">{list.payment_ref || 'N/A'}</td>
            <td>{relocation_helpers.relocationStatusLabels(list.relocation_status)}</td>
            <td>
              <div className="d-flex">
                <button
                  type="submit"
                  className="mx-1 noBorder"
                  data-toggle="modal"
                  data-placement="right"
                  data-target="#viewRelocation"
                  onClick={() => getRequest(list)}
                >
                  <span className="view">
                    <img src={view} alt="" data-toggle="tooltip" data-placement="left" title="View" />
                  </span>
                </button>
                {department_id === SALES && (
                  <button
                    type="submit"
                    className="mx-1 noBorder"
                    data-toggle="modal"
                    data-placement="right"
                    data-target="#editRelocation"
                    onClick={() => getRequest(list)}
                  >
                    <span className="view">
                      <img src={edit} alt="" data-toggle="tooltip" data-placement="left" title="Edit" />
                    </span>
                  </button>
                )}
              </div>
            </td>
            <EditRelocation request={request} />
            <ViewRelocation request={request} />
          </tr>
        );
      })
    ) : (
      <NoItemRow colSpan={colSpan} text="There are no requests for relocation" />
    );

  return (
    <div className="table-responsive content col-12">
      <table className="table table-striped">
        <thead>
          <tr className="">
            <th>S/N</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Old Address</th>
            <th>Payment REF</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>{isLoading ? <TizetiGIFLogoTable colSpan={colSpan} /> : tableData}</tbody>
      </table>
    </div>
  );
};

export default RelocationTable;
